
import Vue from "vue";
import { Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule, TruckModule } from "@/store/modules";
import uncompletedOrdersModal from "@/components/widgets/Modals/UncompletedOrdersModal.vue"
const supportedGetters = ["order", "truck"];
supportedGetters["order"] = "order/getSelectedOrders";
supportedGetters["truck"] = "truck/getSelectedTrucks";

@Component({
  components:{
    uncompletedOrdersModal
  }
})
export default class OrderNavbar extends Vue {
  orderModule: OrderModule = getModule(OrderModule);
  truckModule: TruckModule = getModule(TruckModule);
  uncompletedOrdersCounts: number = 0;
    showUncompletedOrdersModal: Boolean = false;

  @Prop({ default: [] })
  shortcuts: Array<any>;

  @Prop({ default: false })
  isDispatch: boolean;

  @Prop({ default: 0 })
  deliveryForId: number | null;

  @Prop({ default: () => null })
  target: Object;

  @Prop({ default: "order" })
  type: string;

  @Prop({ default: false })
  isOrderDetail: boolean;

  @Prop({ default: false })
  canAddRequiredStock: boolean;

  get shortcutsToDisplay() {
    let shortcuts = this.shortcuts.filter(
      x =>  ( !this.deliveryForId && 
                (x.requiresPermission === undefined || this.hasPermission(x.requiresPermission) )) 
            ||
            ( !!this.deliveryForId && 
                (x.requiresAgentPermission === undefined || this.hasPermission(x.requiresAgentPermission) )) 
            ||
            ( this.isDispatch && 
                (this.hasPermission(x.requiresPermission) === undefined  || this.hasPermission(x.requiresPermission) || this.hasPermission(x.requiresAgentPermission) )) 
            ||
            (  x.title === "New Order"  && 
                (this.hasPermission(x.requiresPermission) || this.hasPermission(x.requiresAgentPermission) )) 

    );
    if(!this.isDispatch && !this.isOrderDetail){
      shortcuts = shortcuts.filter(x => x.title != "Refresh")
    }

    return shortcuts
  }

  showUOModal(){
    this.showUncompletedOrdersModal = true;
  }

  set uncompletedOrdersCount(count: any){
      this.uncompletedOrdersCounts = count;
  }

  get uncompletedOrdersCount(){
     return this.uncompletedOrdersCounts;
  }

  getSelectedItems() {
    if (this.type === "order") {
      return this.orderModule.selectedOrders;
    } else if (this.type === "truck") {
      return this.truckModule.getSelectedTrucks;
    }
  }

  async executeAction(shortcut) {
    let payload = null;
    const selectedItems = this.getSelectedItems();
    if (shortcut.requiresSelection && (!selectedItems || selectedItems.length < 1)) {
      this.$bvModal.msgBoxOk("Please select orders");
      return;
    }

    if (shortcut.maxSelection && selectedItems.length > shortcut.maxSelection) {
      this.$bvModal.msgBoxOk(
        `Too many orders selected. You can only select ${shortcut.maxSelection} order(s) for this action.`
      );
      return;
    }

    if (shortcut.title == 'Add to Truck' && (this.orderModule.selectedOrders.some(x => x.orderType == 'WILL') || this.orderModule.currentOrder.orderType === "WILL")) {
      this.$bvModal.msgBoxOk("Will Call orders cannot be added to a truck");
      return;
    }

    if (!this.target) payload = { selectedItems: selectedItems };
    else payload = { selectedItems: [this.target] };
    const returnedValue: any = await this.$store.dispatch(shortcut.action, payload, { root: true });
    if(shortcut.title == 'Save')
    {
      const uncompletedOrdersCount = returnedValue
      this.uncompletedOrdersCount = uncompletedOrdersCount
      if(uncompletedOrdersCount){
        this.showUOModal()
      }
    }
  }
}
